<template>
  <v-dialog
    v-model="show"
    width="800"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Participantes ativos {{ totalUsers }}</v-toolbar-title>
      </v-toolbar>

      <template v-if="visibleToSeller">
        <UsersSellOut
          v-if="show"
          v-bind="$attrs"
          @totalUsers="setTotalUsers"
          :apportionment="apportionment"
          apportionment-type="participant"
        />
        <UsersSellOut
          v-if="show"
          v-bind="$attrs"
          @totalUsers="setTotalUsers"
          :apportionment="apportionment"
          apportionment-type="seller"
        />
      </template>

      <template v-else>
        <UsersSellOut
          v-if="show"
          v-bind="$attrs"
          @totalUsers="setTotalUsers"
          :apportionment="apportionment"
          apportionment-type="participant"
        />
      </template>

      <v-card-actions class="justify-end">
        <v-btn
          @click="close"
          color="primary"
          outline
          large
        >
          Cancelar
        </v-btn>

        <v-btn
          @click="confirm"
          color="primary"
          large
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UsersSellOut from './UsersSellOut.vue'
import {
   getCampaignApportionment,
} from '@/services/containers/partners/campaignsApportionment'
import EventBus from '@/helpers/eventbus'
import { ANALYTICS_EVENTS } from '@/helpers/consts'

export default {
  name: 'UsersSellOutModal',
  components: {
    UsersSellOut
  },
  data() {
    return {
      show: false,
      totalUsers: null,
      visibleToSeller: false,
      apportionment: null
    }
  },
  async created() {
    this.getApportionment()
  },
  methods: {
    open() {
      EventBus.$emit(ANALYTICS_EVENTS.track.sellOutSawReport)
      this.show = true
    },

    close() {
      this.show = false
    },

    confirm() {
      EventBus.$emit(ANALYTICS_EVENTS.track.sellOutConfirmReport)
      this.close()
      this.$emit('confirm')
    },

    setTotalUsers(total) {
      this.totalUsers = `(${total})`
    },

    async getApportionment() {
      this.$showLoading()
      try {
        const { id } = this.$route.params
         const { data } = await getCampaignApportionment(id)
         this.visibleToSeller = data.visibleToSeller
         this.apportionment = data
         this.$hideLoading()
         } catch (err) {
         this.$hideLoading()
         if (err.response.data.message.includes('não encontrado')) return
         this.$toast(err.response.data.message, 'red')
       }
    },
  }
}
</script>

